class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    // 변경: form이 없으면 이벤트 바인딩을 시도하지 않음
    if (facetForm) facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    // 변경: onKeyUpEscape가 함수인지 확인 후 바인딩
    if (facetWrapper && typeof onKeyUpEscape === 'function') facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.initHorizontalFacets();
  }
  initHorizontalFacets() {
    if (this.classList.contains('facets__horizontal')) {
      this.setupHorizontalFacets();
    }
    this.horizontalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          if (this.classList.contains('facets__horizontal')) {
            this.setupHorizontalFacets();
          }
        }
      });
    });
    this.querySelector('#FacetsWrapperDesktop') && this.horizontalObserver.observe(this.querySelector('#FacetsWrapperDesktop'), {
      childList: true,
      subtree: false
    });
  }
  setupHorizontalFacets() {
    document.removeEventListener('click', this.closeTab);
    this.querySelectorAll('.facets__disclosure__horizontal summary').forEach(item => {
      item.removeEventListener('click', this.openTab);
    });
    document.addEventListener('click', this.closeTab.bind(this));
    this.querySelectorAll('.facets__disclosure__horizontal summary').forEach((item) => {
      item.addEventListener('click', this.openTab.bind(this));
    });
  }
  openTab(event){
    var current = event.target.closest('details');
    if(current.classList.contains('details__opened')){
      current.classList.remove('details__opened');
    }else{
      setTimeout(function(){current.classList.add('details__opened');}, 100)
    }
  }
  closeTab(event){
    if(!this.classList.contains('facets__horizontal')) return;
    var index = -1;
    var current = event.target.closest('details');
    if(current){
      index = current.getAttribute('data-index');
    }
    this.querySelectorAll('.facets__disclosure__horizontal[open]').forEach((item) => {
      if(item.getAttribute('data-index') != index){
        item.removeAttribute('open');
        item.classList.remove('details__opened');
        item.querySelector('summary').setAttribute('aria-expanded', false);
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static removePreloader() {
    const productGrid = document.getElementById('ProductGridContainer');
    const facetsLoader = document.querySelector('.collection_facets_loader');
    if (productGrid) productGrid.classList.remove('loading_now');
    if (facetsLoader) facetsLoader.classList.remove('loading_now');
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    placeCollectionLoader();
    document.getElementById('ProductGridContainer').classList.add('loading_now');
    document.querySelector('.collection_facets_loader').classList.add('loading_now');
    
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  // 추가: 서버 반환 HTML을 안전하게 정리하여 스크립트 제거
  static sanitizeHtml(html) {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('script').forEach((s) => s.remove());
      return doc.documentElement.outerHTML;
    } catch (e) {
      return html;
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = FacetFiltersForm.sanitizeHtml(responseText);
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        FacetFiltersForm.removePreloader();
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
      })
      .catch((err) => {
        console.warn('renderSectionFromFetch error', err);
        FacetFiltersForm.removePreloader();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cached = FacetFiltersForm.filterData.find(filterDataUrl);
    const html = cached ? FacetFiltersForm.sanitizeHtml(cached.html) : '';
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);    
    FacetFiltersForm.removePreloader();
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html);
  }

  static renderProductGridContainer(html) {
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('script').forEach(script => script.remove());
      const source = doc.getElementById('ProductGridContainer');
      const dest = document.getElementById('ProductGridContainer');
      // 변경: source/dest 존재 확인 후 교체
      if (source && dest) {
        dest.innerHTML = source.innerHTML;
        dest.querySelectorAll('.scroll-trigger').forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });
        // 추가: 렌더 완료 이벤트 (다른 스크립트가 안전하게 재초기화 가능)
        window.dispatchEvent(new CustomEvent('facets:rendered'));
      }
    } catch (e) {
      console.warn('renderProductGridContainer failed', e);
    }
  }

  static renderProductCount(html) {
    const countContainer = document.getElementById('ProductCount');
    if(!countContainer) return false;
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('script').forEach(script => script.remove());
      const sourceCount = doc.getElementById('ProductCount');
      if (sourceCount) {
        countContainer.innerHTML = sourceCount.innerHTML;
      }
    } catch (e) {
      console.warn('renderProductCount failed', e);
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    // 파싱 직후에도 스크립트 제거 (추가 안전성)
    parsedHTML.querySelectorAll('script').forEach(script => script.remove());

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    var removed = false;
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.closest('details').remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (elementToRender.parentElement) {
          var _parent_current = document.querySelector(`#${elementToRender.parentElement.id}`);
        }
        if (index > 0 && elementToRender.parentElement && _parent_current) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          var _index = elementToRender.parentElement.dataset.index;
          var _fl = document.querySelector(`#${elementToRender.parentElement.id}`);
          if(_fl){
            if(_fl.querySelector(`.js-filter`)){
              _fl.querySelector(`.js-filter`).before(elementToRender);
            }
          }
          else{
            if(elementToRender.parentElement.classList.contains('mobile-facets__details')){
              var parent = document.querySelector(`#FacetFiltersFormMobile .facet-drawer__content__scroll`);
            }
            else{
              var parent = document.querySelector(`#FacetsWrapperDesktop`);
            }
            parent.insertBefore(elementToRender.parentElement, parent.children[_index])
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      // 변경: event가 없거나 target이 없을 경우 안전하게 처리
      const closestJSFilterEl = event && event.target && event.target.closest && event.target.closest('.js-filter');
      if (closestJSFilterEl) {
        const closestJSFilterID = closestJSFilterEl.id;
        FacetFiltersForm.renderCounts(countsToRender, closestJSFilterEl);
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement && newFacetDetailsElement.classList && newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement && newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event && event.target && event.target.getAttribute && event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      // 변경: target 존재 확인
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      const targetEl = document.querySelector(selector);
      // 변경: source/target 존재 확인
      if (!sourceEl || !targetEl) return;
      targetEl.innerHTML = sourceEl.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm && mobileForm.closest) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.isDualRange = this.classList.contains('facets__price--dual-range');
    
    if (this.isDualRange) {
      this.initDualRangeSlider();
    } else {
      this.initLegacyInputs();
    }
  }

  initDualRangeSlider() {
    this.minSlider = this.querySelector('.price-range__input--min');
    this.maxSlider = this.querySelector('.price-range__input--max');
    this.minTextInput = this.querySelector('.price-range__text-input--min');
    this.maxTextInput = this.querySelector('.price-range__text-input--max');
    this.trackFill = this.querySelector('.price-range__track-fill');
    this.minDisplayValue = this.querySelector('.price-range__value--min .price-value');
    this.maxDisplayValue = this.querySelector('.price-range__value--max .price-value');
    
    if (!this.minSlider || !this.maxSlider) return;
    
    // data 속성에서 범위 값 가져오기
    this.rangeMin = parseFloat(this.dataset.rangeMin) || 0;
    this.rangeMax = parseFloat(this.dataset.rangeMax) || 1000;
    this.currentMin = parseFloat(this.dataset.currentMin) || 0;
    this.currentMax = parseFloat(this.dataset.currentMax) || this.rangeMax;
    
    // 초기값 설정
    this.minSlider.value = this.currentMin;
    this.maxSlider.value = this.currentMax;
    
    // 슬라이더 이벤트
    this.minSlider.addEventListener('input', this.onMinSliderInput.bind(this));
    this.maxSlider.addEventListener('input', this.onMaxSliderInput.bind(this));
    this.minSlider.addEventListener('change', this.onSliderChange.bind(this));
    this.maxSlider.addEventListener('change', this.onSliderChange.bind(this));
    
    // 텍스트 입력 이벤트
    if (this.minTextInput) {
      this.minTextInput.addEventListener('change', this.onMinTextChange.bind(this));
      this.minTextInput.addEventListener('keydown', this.onKeyDown.bind(this));
    }
    if (this.maxTextInput) {
      this.maxTextInput.addEventListener('change', this.onMaxTextChange.bind(this));
      this.maxTextInput.addEventListener('keydown', this.onKeyDown.bind(this));
    }
    
    this.updateTrackFill();
    this.updateDisplay();
  }

  onMinSliderInput(event) {
    let minVal = parseFloat(this.minSlider.value);
    const maxVal = parseFloat(this.maxSlider.value);
    const gap = 0.01; // 센트 단위 최소 간격
    
    if (minVal >= maxVal - gap) {
      minVal = maxVal - gap;
      this.minSlider.value = minVal;
    }
    
    this.updateDisplay();
    this.updateTrackFill();
  }

  onMaxSliderInput(event) {
    const minVal = parseFloat(this.minSlider.value);
    let maxVal = parseFloat(this.maxSlider.value);
    const gap = 0.01;
    
    if (maxVal <= minVal + gap) {
      maxVal = minVal + gap;
      this.maxSlider.value = maxVal;
    }
    
    this.updateDisplay();
    this.updateTrackFill();
  }

  onSliderChange(event) {
    const minVal = parseFloat(this.minSlider.value).toFixed(2);
    const maxVal = parseFloat(this.maxSlider.value).toFixed(2);
    
    // 텍스트 입력 필드 업데이트 (달러 단위 유지)
    if (this.minTextInput) {
      this.minTextInput.value = minVal > 0 ? minVal : '';
    }
    if (this.maxTextInput) {
      this.maxTextInput.value = maxVal < this.rangeMax ? maxVal : '';
    }
    
    // 폼 제출 트리거
    const inputToTrigger = this.minTextInput || this.maxTextInput;
    if (inputToTrigger) {
      inputToTrigger.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onMinTextChange(event) {
    // 텍스트 입력값은 달러 단위
    let value = parseFloat(this.minTextInput.value) || 0;
    
    if (value < this.rangeMin) value = this.rangeMin;
    if (value >= this.currentMax) value = this.currentMax - 0.01;
    
    this.minSlider.value = value;
    this.currentMin = value;
    this.updateDisplay();
    this.updateTrackFill();
  }

  onMaxTextChange(event) {
    let value = parseFloat(this.maxTextInput.value) || this.rangeMax;
    
    if (value > this.rangeMax) value = this.rangeMax;
    if (value <= this.currentMin) value = this.currentMin + 0.01;
    
    this.maxSlider.value = value;
    this.currentMax = value;
    this.updateDisplay();
    this.updateTrackFill();
  }

  updateDisplay() {
    const minVal = parseFloat(this.minSlider.value).toFixed(2);
    const maxVal = parseFloat(this.maxSlider.value).toFixed(2);
    
    if (this.minDisplayValue) this.minDisplayValue.textContent = minVal;
    if (this.maxDisplayValue) this.maxDisplayValue.textContent = maxVal;
  }

  updateTrackFill() {
    if (!this.trackFill) return;
    
    const min = parseFloat(this.minSlider.min);
    const max = parseFloat(this.minSlider.max);
    const minVal = parseFloat(this.minSlider.value);
    const maxVal = parseFloat(this.maxSlider.value);
    
    const percentMin = ((minVal - min) / (max - min)) * 100;
    const percentMax = ((maxVal - min) / (max - min)) * 100;
    
    this.trackFill.style.left = percentMin + '%';
    this.trackFill.style.width = (percentMax - percentMin) + '%';
  }

  initLegacyInputs() {
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
      element.addEventListener('input', this.onInputChange.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onInputChange(event) {
    const input = event.currentTarget;
    let value = input.value;
    
    if (value.startsWith('-')) {
      input.value = value.replace(/-/g, '');
    }
    
    const cleanValue = value.replace(/[^0-9.,\s]/g, '');
    if (cleanValue !== value) {
      input.value = cleanValue;
    }
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
    
    if (event.key === '-') event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('.price-range__inputs input, .facets__price__item input');
    if (inputs.length < 2) return;
    
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('max') || maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    let value = Number(String(input.value).replace(/[^0-9.]/g, ''));
    const min = Number(input.getAttribute('data-min') || input.getAttribute('min')) || 0;
    const max = Number(input.getAttribute('data-max') || input.getAttribute('max'));

    if (value < 0) value = 0;
    if (value < min) value = min;
    if (max && value > max) value = max;
    
    input.value = value || '';
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    // 변경: anchor가 없으면 안전하게 종료
    if (!facetLink) return;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);